import Slot from './Slot';

export default Slot;
